<template>
  <div class="container-fluid p-3">
    <div class="card">
      <div class="card-body">
        <h5 class="text-center">REPORTE DE PARTES DECLARADAS POR EMPRESA</h5>

        <div class="row">          

          <div class="col-lg-3">
            <div class="form-group">
              <label class=" mr-1">Empresas:</label>
              <select class="form form-control" v-model="id_empresa">
                <option
                  v-for="(item, index) in empresas"
                  :key="index"
                  :value="item.id_empresa"
                >
                  {{ item.emp_razon_social }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-lg-3 mt-2"><br>
            <a
              class="btn btn-info mr-1"
              title="Buscar"
              @click="listarDatos(id_empresa)"
            >
              <i class="fa fa-search"></i> Buscar
            </a>
          </div>
        </div>

        <div
          class="table-responsive mt-3"
          style="overflow-y:scroll; height:380px;"
        >
          <table class="table table-bordered">
            <tr class="text-center">
              <th><small class="font-weight-bold">NRO.</small></th>
              <th><small class="font-weight-bold">FECHA INICIO</small></th>
              <th><small class="font-weight-bold">FECHA FIN</small></th>
              <th><small class="font-weight-bold">TOTAL</small></th>
              <th><small class="font-weight-bold">ACCIONES</small></th>
            </tr>
            <tr v-for="(item, index) in registros" :key="index">
              <td>
                <small>{{ index + 1 }}</small>
              </td>
              <td>
                <small>{{ formatFecha(item.fecha_inicio) }}</small>
              </td>
              <td>
                <small v-if="item.fecha_fin!==null">{{ formatFecha(item.fecha_fin) }}</small>
                <small v-else></small>
              </td>
              <td>
                <small>{{ item.totalregistros }}</small>
              </td>
              <td class="text-center">
                <a
                  class="btn btn-outline-success btn-sm mr-1"
                  title="Descargar Parte"
                  @click="exportarXls(undefined, undefined, id_empresa, item.fecha_inicio, item.fecha_fin)">
                  <i class="fa fa-download"></i>
                </a>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <Loading v-show="cargando" />
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import moment from "moment";

export default {
  components: {
    Loading,
  },
  data() {
    return {
      registros: [],
      resultados: [],
      empresas: [],
      rubros: [],
      departamentos: [],
      options: [],
      elegido: {},
      buscar: "",
      filtro: "1",
      id_empresa: 0,
      submitted: false,
      cargando: false,
    };
  },
  methods: {
    async listarDatos(id_empresa) {
      try {
        this.resultados = await this.axios.get(`/empresa/partesEmpresa/${id_empresa}`);
        this.registros = this.resultados.data.contenido;
        
      } catch (error) {
        console.log(error);
        
      }
    },
    async listarEmpresas() {
      try {
        let resultados = await this.axios.get(`listaEmpresaReporteExcel`);
        this.empresas = resultados.data.contenido;
        
      } catch (error) {
        console.log(error);
      }
    },
    getDate: function(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    formatFecha(event) {
      let str = event;
      let arrayFecha = str.split("-");
      return arrayFecha[2] + "/" + arrayFecha[1] + "/" + arrayFecha[0];
    },
    crearDescarga(response, title) {
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'blob' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', title);
      document.body.appendChild(link);
      link.click();
    },
    async exportarXls(codigo_departamento, id_rubro, id_empresa, fecha_inicio, fecha_fin){
      let config = { headers: {token: this.token}, responseType: 'blob'};
      this.cargando= true;
      try {
        this.resultados = await this.axios.get(`/partes/personasPartesporEmpresa/${id_empresa}/${fecha_inicio}/${fecha_fin}`, config);
        await this.crearDescarga(this.resultados, 'reporte.xlsx');
        this.cargando = false;
      } catch (error) {
        console.log(error);
        this.cargando = false;
      }
    }
  },
  created() {
    this.listarEmpresas();
  },
};
</script>
